import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['meetAppliesDownloadDesc'];

  downloadMeetApplies(evt) {
    if (this.meetAppliesDownloadDescTarget.value === '') {
      evt.preventDefault();
      window.$sendAlert('다운로드 사유를 작성해주세요');
      return;
    }
    this.element.dispatchEvent(new CustomEvent('toggle', evt));
  }
}
